export default {
  data: {
    config: null,
  },

  getEnv: function() {
    switch (process.env.NODE_ENV) {
      case "local":
        this.data.config = require("@/config/config-local.json");
        break;
      case "staging":
        this.data.config = require("@/config/config-staging.json");
        break;
      case "development":
        this.data.config = require("@/config/config-development.json");
        break;
      case "production":
        this.data.config = require("@/config/config-production.json");
        break;
      default:
        this.data.config = require("@/config/config-production.json");
        break;
    }
    return this.data.config;
  },
}